<template>
  <DaiTarjetaContenedorMapa
    class="fix"
    :es-version-escritorio-en-pantalla-larga="true"
    altura-colapsada="650px"
    etiqueta-colapso="Más información"
    etiqueta-no-colapso="Menos información"
  >
    <Loader v-if="!cargaLista" />

    <template #header>
      <h3 v-width-control="'100%'">Rendimiento de cultivos</h3>
      <p>
        Haz clic sobre el estado para ver información a nivel municipal
      </p>
      <button class="dai-map-button control-small boton-ver-municipios" 
        @click="verMunicipios()">
        {{ nivelActual==='x-estados'? 'Ver por municipios': 'Ver por estados' }}
      </button>
    </template>

    <DaiMapa ref="mapa"
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]"
      @reset_view="resetMap"
      
    >
      <DaiCapaXyz />
      <!--La capa estatal-->
      <DaiCapaGeojson
        v-if="cargaLista"
        ref="capaEstados"
        :datos="{type: 'FeatureCollection', features: JSON.parse(limitesEnt)}"
        :z-index="1"
        :estilo-capa="{
          fill: {color: 'transparent'},
          stroke: {color: '#4CA345', width: 1.6},
        }"
        :contenidoTooltip="contenidoTooltip"
        @click_feature="clickEntidad"
      />
      <!--La capa de puntos (simbolos graduados)-->
      <DaiCapaGeojson 
        v-if="cargaLista"
        :key="`centroides_${actualizador}`"
        :id="`centroides_${actualizador}`"
        :datos="{type: 'FeatureCollection', features: JSON.parse(centroides)}"
        :z-index="3"
        :estilo-capa="{circle: {
          fill: {color: `${dicCultivos[cultivoSeleccionado].color}B3`},
          stroke: {color: '#CCCCCC', width: 1},
        },}"
        :reglas-estilo-capa="[
          {
            clasificacion: 'personalizada',
            propiedadObjetivo: 'proporcion',
            columna: `${cultivoSeleccionado}`,
            clasificacionPersonalizada: dicCultivos[cultivoSeleccionado].clases[nivelActual],
            proporciones: [0, 3, 6, 9, 12],
            tituloVariable: `${dicCultivos[cultivoSeleccionado].titulo}`
          }
        ]"
        :contenidoTooltip="contenidoTooltip"
        :zoom-al-dar-click="false"
        @click_feature="clickEntidad($event,true)"
      />
      <!--La capa municipal , limites-->
      <DaiCapaGeojson
        v-if="cargaLista && (limitesMun.length>0)"
        :datos="{type: 'FeatureCollection', features: JSON.parse(limitesMun)}"
        :z-index="2"
        :estilo-capa="{
          fill: {color: 'transparent'},
          stroke: {color: '#4CA345', width: .8},
        }"
        :contenidoTooltip="contenidoTooltip"
        :zoom-al-dar-click="false"
        @click_feature="clickEntidad($event,true)"
      />
    </DaiMapa>

    <template #footer>
      <div class="control-cultivos">
        <h4 v-width-control="'100%'">Tipo de cultivo</h4>
        <label v-for="(cultivo, id) in dicCultivos" :key="id">
          <input type="radio" name="cultivos"
            :id="id"
            :value="id"
            @change="cambiarTipo()"
            v-model="cultivoSeleccionado"> {{cultivo.titulo}} <i></i>
        </label>
      </div>

      <hr class="dai-map-separator thin">
      <DaiLeyendaMapa class="leyenda-reverse leyenda-ocultando-ceros"
        :key="`centroides_${actualizador}`"
        :para="`centroides_${actualizador}`"
        titulo="Toneladas por hectárea"
      />
      <hr class="dai-map-separator thin">
      <a class="dai-map-button download" :href="`${cdnArchivos}/cultivos_rendimientos.zip`" download>
        Descargar datos
      </a>
    </template>
  </DaiTarjetaContenedorMapa>
</template>

<script>
import { leerGeoJSON } from './_utils.js'
import Loader from '@/components/utiles/Loader.vue'

const dicCultivos = {
  rendi_maiz_temp: {titulo: 'Maíz de temporal', color: '#FAC460', clases: {
    "x-estados": [[0,0],[1,15],[15,50],[50,250],[250,655]], "x-municipios": [[0,0],[1,1],[2,3],[3,6],[6,8]]}},
  rendi_maiz_riego: {titulo: 'Maíz de riego', color: '#F6FD44', clases: {
    "x-estados": [[0,0],[1,40],[40,100],[100,300],[300,840]], "x-municipios": [[0,0],[1,2],[2,4],[4,8],[8,12]]}},
  rendi_naranja: {titulo: 'Naranja', color: '#ED9444', clases: {
    "x-estados": [[0,0],[1,25],[25,100],[100,500],[500,1020]], "x-municipios": [[0,0],[2,5],[5,15],[15,25],[25,32]]}},
  rendi_aguacate: {titulo: 'Aguacate', color: '#2DD270', clases: {
    "x-estados": [[0,0],[1,15],[15,50],[50,350],[350,930]], "x-municipios": [[0,0],[1,5],[5,10],[10,20],[20,30]]}},
},
nivelesMapa = ['x-estados','x-municipios'],
rutaDatos = `${process.env.VUE_APP_CDN_ARCHIVOS}/impactos/mapa-rendimientos`

export default {
  data() { return {
    dicCultivos: dicCultivos,
    cultivoSeleccionado: 'rendi_maiz_temp',
    nivelesMapa: nivelesMapa,
    nivelActual: nivelesMapa[0],
    entidadActual: undefined,
    centroides: '[]',
    limitesEnt: '[]',
    limitesMun: '[]',
    cargaLista: false,
    actualizador: 0,
    cdnArchivos:  `${process.env.VUE_APP_CDN_ARCHIVOS}/impactos`,
  }},
  mounted() {
    this.cargarCapas()
  },
  methods: {
    cargarCapas(cve_ent,forzarAcercamientoAlEstado=false) {
      this.cargaLista = false
      this.entidadActual = cve_ent
      if (this.entidadActual === undefined) {
        leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_est_a.geojson`)
        .then(data => {
          this.limitesEnt = JSON.stringify(data.features)

          if (this.nivelActual===nivelesMapa[0]) {
            this.limitesMun = '[]'
            leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_est_p.geojson`)
            .then(data => {
              this.centroides = JSON.stringify(data.features)
              this.esconderLoader()
            })
          } else {
            leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_mun_p.geojson`)
            .then(data => {
              //no agregar datos en nulo (solo para centroides)
              this.centroides = JSON.stringify(data.features.filter(feature=>feature.properties[this.cultivoSeleccionado]!==null ))

              leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_mun_a.geojson`)
              .then(data => {
                this.limitesMun = JSON.stringify(data.features)
                this.esconderLoader()
              })
            })
          }
        })
      } else {
        leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_est_a.geojson`)
        .then(data => {
          this.limitesEnt = JSON.stringify(data.features
            .filter(f => f.properties.cve_ent===this.entidadActual))
          
          leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_mun_p.geojson`)
          .then(data => {
            this.centroides = JSON.stringify(data.features
              .filter(f => f.properties.cve_ent.substr(0,2)===this.entidadActual && f.properties[this.cultivoSeleccionado]!==null ))

            leerGeoJSON(`${rutaDatos}/glifo_rendimiento_ha_4_cultivos_20_mun_a.geojson`)
            .then(data => {
              this.limitesMun = JSON.stringify(data.features
                .filter(f => f.properties.cve_ent.substr(0,2)===this.entidadActual))
              
              this.nivelActual = nivelesMapa[1]
              this.esconderLoader()
              if(forzarAcercamientoAlEstado){
                setTimeout(()=>{
                  //console.log(this.$refs.capaEstados.olLayer.getSource().getFeatures()[0])
                  this.$refs.mapa.map.getView().fit(this.$refs.capaEstados.olLayer.getSource().getFeatures()[0].getGeometry(),{duration:500,padding:[25,25,25,25]})    
                },1200)
              }
            })
          })
        })
      }
    },
    contenidoTooltip(f) {
      return `<b class="renglon-tooltip">
          ${f.nom_mun? `${f.nom_mun}, ${f.nom_ent}`: f.nom_ent}
        </b><br><span class="renglon-tooltip">
          ${dicCultivos[this.cultivoSeleccionado].titulo}: 
          ${f[this.cultivoSeleccionado]!=null
          ? `${f[this.cultivoSeleccionado]} ton/ha`: 'Sin dato'
        }</span>`
    },
    clickEntidad([f,], forzarAcercamiento=false) {
      //console.log("clickEntidad",forzarAcercamiento)
      console.log(f)
      if (this.nivelActual===nivelesMapa[0]) {
        this.cargarCapas(f.get('cve_ent'),forzarAcercamiento)
      } else if (this.entidadActual == undefined) {
        //console.log(f.get('cve_ent').substr(0,2));
        this.cargarCapas(f.get('cve_ent').substr(0,2),forzarAcercamiento)
      }
    },
    verMunicipios() {
      if (this.nivelActual===nivelesMapa[0]) {
        this.nivelActual = nivelesMapa[1]
        this.cargarCapas()
      } else {
        this.nivelActual = nivelesMapa[0]
        this.cargarCapas()
      }
    },
    resetMap() {
      if (this.nivelActual===nivelesMapa[1]) {
        this.nivelActual = nivelesMapa[0]
        this.cargarCapas()
      }
      this.nivelActual = nivelesMapa[0]
    },
    cambiarTipo() {
      this.cargaLista = false
      this.actualizador++
      this.esconderLoader()
    },
    esconderLoader() {
      setTimeout(() => {
        //El resize map sin acercarse a toda la republica de nuevo
        this.$refs.mapa.forceResizeMap(false)
        this.cargaLista = true
      },1000)
    },
  },
  components: {
    Loader,
  },
}
</script>

<style lang="scss">
.fix {
  overflow: hidden;
}
.control-cultivos {
  label {
    position: relative;
    margin-bottom: 12px;
    padding: 5px 0 5px 50px;
    display: block;
    cursor: pointer;

    input[type=radio] {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      visibility: hidden;
      position: absolute;
      right: 0;

      + i {
        background: #fff;
        border: 1.5px solid #000;
        position: absolute; 
        left: 0;
        top: 0;
        height: 26px;
        width: 26px;
        border-radius: 100%;
        left: 5px;

        &:before {
          content: '';
          display: block;
          height: 18px;
          width: 18px;
          border-radius: 100%;
          position: absolute;
          z-index: 1;
          top: 3px;
          left: 3px;
          background:#000;
          transition: all 0.25s ease;
          transform: scale(0);
          opacity: 0;
        }
      }

      &:checked + i:before{
        transform: scale(1);
        opacity: 1;
      }
    }

    &:hover input[type=radio]:not(:checked) + i{
      background: #d0d0d0;
    }
  }
}

.leyenda-ocultando-ceros{
  min-height: 126px;
  .shapes{
    >div.shape-item:first-of-type{
      display: none;
    }
  }
}

a.dai-map-button.download{
  display: block;

  &:hover,&:focus{
    background-color: #000;
    box-shadow: none;
    color: #fff;
  }
}
</style>
